import React from 'react';
import classnames from 'classnames/bind';
import _ from 'lodash';

import styles from './badgesStyles';

import Badge from 'buyside/components/presentation/Badges/Badge/badge';

const cx = classnames.bind(styles);

const Badges = props => {
  const { userBadges, inline, badgeClass, className = '', showExtendedInfo } = props;
  if (!userBadges || !userBadges.length) return null;
  if (!_.find(userBadges, badge => badge.node && badge.node.visible)) return null;
  const badges = [...userBadges].sort((a, b) => {
    return a.node.badge.order - b.node.badge.order;
  });
  return (
    <div className={cx('badgesArea', { inline }, className)}>
      {!inline && <div>Badges:</div>}
      <div className={cx('badgesList', { inline })}>
        {badges.map(userBadge => {
          if (!userBadge.node.visible) return null;
          return (
            <Badge
              badgeInfo={userBadge.node}
              key={userBadge.node.id}
              badgeClass={badgeClass}
              showExtendedInfo={showExtendedInfo}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Badges;
